import { CandidateExpandedContent } from './CandidateExpandedContent';

export default CandidateExpandedContent;
